import React, { useRef } from "react";

import classnames from "classnames";
import { RightArrow, Unlink } from "icons";
import { useDrag } from "react-dnd";

import { Tooltip, Typography } from "clearsense-ui/components";

const ValueCard = ({
  value,
  handleValueSelection,
  highlightedValue,
  disassociateValue,
  style,
}) => {
  const [{ isDragged, cursor }, drag] = useDrag(
    () => ({
      type: "referenceSourceValue",
      item: { value },
      canDrag: !value.isMapped,
      collect: monitor => ({
        isDragged: monitor.isDragging(),
        cursor: monitor.isDragging() ? "grabbing" : "grab",
      }),
    }),
    [value]
  );

  const cardStyle = () => {
    if (highlightedValue.id === value.id && value.isMapped) {
      return "selected";
    } else if (value.isMapped && value.isHighLighted) {
      return "highlighted";
    } else if (value.isMapped) {
      return "mapped";
    }

    return "unmapped";
  };

  const cardRef = useRef();

  return (
    <div
      data-cy="reference-source-draggable-card"
      ref={drag}
      style={{ cursor, ...style }}
      className={classnames(
        "bg-gray-50 border border-solid border-gray-300 p-2 rounded-md shadow-sm flex justify-between space-x-10 dark:bg-gray-700 dark:text-gray-100 select-none w-full dark:border-black h-16",
        {
          "bg-blue-100 cursor-pointer dark:bg-blue-500 dark:text-white":
            cardStyle() === "highlighted",
        },
        {
          "bg-gray-200 text-gray-400 cursor-pointer dark:bg-gray-500 dark:text-white":
            cardStyle() === "mapped",
        },
        {
          "bg-indigo-500 border-indigo-500 text-white cursor-pointer dark:bg-indigo-600":
            cardStyle() === "selected",
        },
        { "opacity-40": isDragged }
      )}
      onClick={() => handleValueSelection(value)}
      key={value.id}
    >
      <Tooltip
        content={value.name}
        disabled={
          cardRef?.current?.scrollWidth <= cardRef?.current?.clientWidth ||
          isDragged
        }
      >
        <div className="flex flex-col space-y-1">
          <Typography
            className="overflow-hidden overflow-ellipsis w-full"
            ref={cardRef}
          >
            {value.name}
          </Typography>
          <Typography
            style="small"
            className={classnames(
              "text-gray-400",
              {
                "dark:text-white": cardStyle() === "highlighted",
              },
              { "dark:text-white": cardStyle() === "selected" }
            )}
          >
            {value.description}
          </Typography>
        </div>
      </Tooltip>
      {value.isMapped ? (
        <Unlink
          data-cy="value-unlink-icon"
          size={14}
          onClick={event => disassociateValue(event, value.id)}
          className={classnames("m-auto dark:text-white", {
            "text-white": cardStyle() === "selected",
          })}
        />
      ) : (
        <RightArrow size={12} className="m-auto" />
      )}
    </div>
  );
};

export default ValueCard;
